import { isPast, isValid } from "date-fns";
import dayjs from "dayjs";
import isAbsoluteUrl from "is-absolute-url";

export const topBarHeight = 75;
export const sideNavWidth = 260;
export const navbarHeight = 60;
export const sidenavCompactWidth = 80;
export const containedLayoutWidth = 1200;
export const ROLE_SA = "SA";
export const ROLE_CANDIDATE = "candidate";
export const ROLE_COMPANY = "company";

export const JobTableHeadersForHR = [
  { label: "Company", width: "180px", align: "left" },
  { label: "Title", width: "200px", align: "left" },
  { label: "Posted On", width: "120px", align: "center" },
  { label: "Type", width: "120px", align: "center" },
  { label: "Experience", width: "120px", align: "center" },
  { label: "City", width: "140px", align: "left" },
  { label: "Edit", width: "80px", align: "center" },
  { label: "Delete", width: "80px", align: "center" },
  { label: "Enable/Disable", width: "80px", align: "center" }
];

export const JobTableHeadersForCandidate = [
  "Company",
  "Title",
  "Posted On",
  "Type",
  "Experience",
  "City",
  "Apply"
];

export const JobTableHeadersForCompany = [
  "Title",
  "Posted On",
  "Expires On",
  "Type",
  "Experience",
  "City",
  "Edit",
  "Delete",
  "Update Status"
];

export const CitiesList = [
  { id: 1, label: "Mumbai" },
  { id: 2, label: "Delhi" },
  { id: 3, label: "Bengaluru" },
  { id: 4, label: "Hyderabad" },
  { id: 5, label: "Ahmedabad" },
  { id: 6, label: "Chennai" },
  { id: 7, label: "Kolkata" },
  { id: 8, label: "Surat" },
  { id: 9, label: "Pune" },
  { id: 10, label: "Jaipur" },
  { id: 11, label: "Lucknow" },
  { id: 12, label: "Kanpur" },
  { id: 13, label: "Nagpur" },
  { id: 14, label: "Indore" },
  { id: 15, label: "Thane" },
  { id: 16, label: "Bhopal" },
  { id: 17, label: "Visakhapatnam" },
  { id: 18, label: "Pimpri & Chinchwad" },
  { id: 19, label: "Patna" },
  { id: 20, label: "Vadodara" },
  { id: 21, label: "Ghaziabad" },
  { id: 22, label: "Ludhiana" },
  { id: 23, label: "Agra" },
  { id: 24, label: "Nashik" },
  { id: 25, label: "Faridabad" },
  { id: 26, label: "Meerut" },
  { id: 27, label: "Rajkot" },
  { id: 28, label: "Kalyan & Dombivali" },
  { id: 29, label: "Vasai Virar" },
  { id: 30, label: "Varanasi" },
  { id: 31, label: "Srinagar" },
  { id: 32, label: "Aurangabad" },
  { id: 33, label: "Dhanbad" },
  { id: 34, label: "Amritsar" },
  { id: 35, label: "Navi Mumbai" },
  { id: 36, label: "Allahabad" },
  { id: 37, label: "Ranchi" },
  { id: 38, label: "Haora" },
  { id: 39, label: "Coimbatore" },
  { id: 40, label: "Jabalpur" },
  { id: 41, label: "Gwalior" },
  { id: 42, label: "Vijayawada" },
  { id: 43, label: "Jodhpur" },
  { id: 44, label: "Madurai" },
  { id: 45, label: "Raipur" },
  { id: 46, label: "Kota" },
  { id: 47, label: "Guwahati" },
  { id: 48, label: "Chandigarh" },
  { id: 49, label: "Solapur" },
  { id: 50, label: "Hubli and Dharwad" },
  { id: 51, label: "Bareilly" },
  { id: 52, label: "Moradabad" },
  { id: 53, label: "Karnataka" },
  { id: 54, label: "Gurgaon" },
  { id: 55, label: "Aligarh" },
  { id: 56, label: "Jalandhar" },
  { id: 57, label: "Tiruchirappalli" },
  { id: 58, label: "Bhubaneswar" },
  { id: 59, label: "Salem" },
  { id: 60, label: "Mira and Bhayander" },
  { id: 61, label: "Thiruvananthapuram" },
  { id: 62, label: "Bhiwandi" },
  { id: 63, label: "Saharanpur" },
  { id: 64, label: "Gorakhpur" },
  { id: 65, label: "Guntur" },
  { id: 66, label: "Bikaner" },
  { id: 67, label: "Amravati" },
  { id: 68, label: "Noida" },
  { id: 69, label: "Jamshedpur" },
  { id: 70, label: "Bhilai Nagar" },
  { id: 71, label: "Warangal" },
  { id: 72, label: "Cuttack" },
  { id: 73, label: "Firozabad" },
  { id: 74, label: "Kochi" },
  { id: 75, label: "Bhavnagar" },
  { id: 76, label: "Dehradun" },
  { id: 77, label: "Durgapur" },
  { id: 78, label: "Asansol" },
  { id: 79, label: "Nanded Waghala" },
  { id: 80, label: "Kolapur" },
  { id: 81, label: "Ajmer" },
  { id: 82, label: "Gulbarga" },
  { id: 83, label: "Jamnagar" },
  { id: 84, label: "Ujjain" },
  { id: 85, label: "Loni" },
  { id: 86, label: "Siliguri" },
  { id: 87, label: "Jhansi" },
  { id: 88, label: "Ulhasnagar" },
  { id: 89, label: "Nellore" },
  { id: 90, label: "Jammu" },
  { id: 91, label: "Sangli Miraj Kupwad" },
  { id: 92, label: "Belgaum" },
  { id: 93, label: "Mangalore" },
  { id: 94, label: "Ambattur" },
  { id: 95, label: "Tirunelveli" },
  { id: 96, label: "Malegoan" },
  { id: 97, label: "Gaya" },
  { id: 98, label: "Jalgaon" },
  { id: 99, label: "Udaipur" },
  { id: 100, label: "Maheshtala" }
];

export const DeletedJobHeaders = ["Posted On", "Title", "Company", "Type", "Restore"];

export const InvoiceTypes = [
  { id: "tax", label: "Tax" },
  { id: "proforma", label: "Proforma" }
];

export const InvoiceStatus = [
  { id: "Active", label: "Active" },
  { id: "Cancelled", label: "Cancelled" }
];

export const CompanyTableHeaders = {
  Company: "jp_company_name",
  State: "jp_state",
  Country: "jp_country",
  Industry: "jp_industry",
  Email: "jp_email"
};

export const CandidateTableHeaders = {
  Name: "jp_name",
  "Contact No": "jp_contactno",
  Email: "jp_email",
  IsActive: "jp_active",
  State: "jp_state",
  Edit: "Edit",
  Delete: "Delete"
};

export const StatusOptions = [
  { label: "Pending", value: "pending" },
  { label: "CV Rejected", value: "cv-rejected" },
  { label: "CV Shortlisted", value: "shortlisted" },
  { label: "Interview Missed", value: "interview-missed" },
  { label: "Interview Rescheduled", value: "interview-rescheduled" },
  { label: "Interview Failed", value: "interview-failed" },
  // { label: "Interview Passed", value: "interview-passed" },
  { label: "Selected", value: "selected" },
  { label: "Offered", value: "offered" },
  { label: "Offer Accepted", value: "offer-accepted" },
  { label: "Joined", value: "joined" },
  { label: "Back Out", value: "backout" },
  { label: "Exit Before Min Tenure", value: "exitBeforeMinTenure" }
];

export function getTodaysDate() {
  const date = new Date();
  const day = date.getDate().toString().padStart(2, "0");
  const month = (date.getMonth() + 1).toString().padStart(2, "0"); // January is 0!
  const year = date.getFullYear();

  return `${day}/${month}/${year}`;
}

export const isValidURL = (url) => {
  if (!url) return true;
  // Accepts www.example.com or example.com (with optional subdomains and TLDs)
  const domainRegex = /^(?:www\.)?[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)+$/;
  return domainRegex.test(url.trim()) || "Please enter a valid domain like www.example.com";
};

export const NameRegex = /^[A-Za-z]+(?:[ '-][A-Za-z]+)*\s*$/;
export const NumberRegex = /^\d+$/;
export const CityRegex = /^[A-Za-z0-9]+(?:[ '-][A-Za-z0-9]+)*\s*$/;
export const EmailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
export const PhoneRegex =
  /^\s*(?=(?:\D*\d){7,15}(?:\D*(?:[xX]|[eE][xX][tT]\.?|[eE][xX][tT][eE][nN][sS][iI][oO][nN])\D*\d{1,6})?\s*$)\+?[0-9](?:[0-9\s().-]*[0-9])?(?:\s*(?:[xX]|[eE][xX][tT]\.?|[eE][xX][tT][eE][nN][sS][iI][oO][nN])\s*\d{1,6})?\s*$/;
export const JobTitleRegex = /^(?![\d\W_]+$)(?!.*[^\w\s.#])[\w\s.#-]+$/;
export const StateRegex = /^([a-zA-Z]+(-[a-zA-Z]+)?)(?:,\s*[a-zA-Z]+(-[a-zA-Z]+)?)*$/;
export const CINRegex = /^[A-Z0-9]{21}$/;
export const PINRegex = /^\d{6}$/;

export function formatExp(value) {
  if (!value) return "";
  if (isFirstDecimalZero(value)) {
    return Math.floor(value); // This will return the value as an integer
  } else {
    return value.toString(); // This will return the value as a string with decimal
  }
}

export const getFormattedExperience = (min_exp, max_exp) => {
  return min_exp && max_exp ? `${formatExp(min_exp)} - ${formatExp(max_exp)} yrs` : "Fresher";
};

export function isFirstDecimalZero(value) {
  if (!value) return false;

  const valueStr = value.toString();

  const parts = valueStr.split(".");

  return parts.length > 1 && parts[1] === "0";
}
export const validateDate = (date) => {
  if (dayjs.isDayjs(date)) {
    return "This field is required";
  }
  if (!isValid(date)) {
    return "Invalid date";
  }
  return true;
};

export const filterAlphabets = (event) => {
  const value = event.target.value;
  event.target.value = value.replace(/[^0-9]/g, "");
};

export const ProfileAvatarStyles = {
  bgcolor: "#222a45"
};

export const LinkStyle = { color: "#1E90FF", textDecoration: "underline" };

export const AppRoutes = {
  ROUTE_JOB_LISTING_SA: "/jobs/listings/sa",
  ROUTE_JOB_LISTING_COMPANY: "/jobs/listings/company",
  ROUTE_DASHBOARD: "/dashboard/default",
  ROUTE_APPLY: "/jobs/apply",
  ROUTE_JOB_DETAIL: "/jobs/job-detail/",
  ROUTE_JOB_LISTING_CANDIDATE: "/jobs/listings/candidate",
  ROUTE_CANDIDATE_APPLIED: "/jobs/candidate/applied",
  ROUTE_COMPANY_APPLIED: "/jobs/company/applied",
  ROUTE_POST_JOB: "/jobs/postjob",
  ROUTE_CANDIDATE_LIST: "/candidate/listings/",
  ROUTE_CANDIDATE_DETAIL: "/candidate/detail/",
  ROUTE_ADD_CANDIDATE: "/candidate/addCandidate/",
  ROUTE_COMPANY_LIST: "/company/listings/",
  ROUTE_ADD_COMPANY: "/company/addCompany",
  ROUTE_PROFILE: "/profile",
  ROUTE_TRASH: "/trash",
  ROUTE_LOGIN_ADMIN: "/session/login/admin",
  ROUTE_LOGIN_CANDIDATE: "/session/login/candidate",
  ROUTE_LOGIN_COMPANY: "/session/login/company",
  ROUTE_SIGNUP_CANDIDATE: "/session/signup/candidate",
  ROUTE_SIGNUP_COMPANY: "/session/signup/company",
  ROUTE_FORGOT_PASSWORD: "/session/forgot-password",
  ROUTE_CURRENT_APPLICATIONS: "/applications/current/sa",
  ROUTE_CHECKOUT: "/checkout"
};

export const pricingModel = {
  candidate: {
    plans: [
      {
        id: "free_trial",
        name: "Free Trial",
        price: 0,
        currency: "INR",
        duration: "for 3 Months",
        features: [{ label: "100 Job Applications / Month", included: true }],
        badge: "Explorer",
        ctaLabel: "Start Free Trial",
        isPopular: false
      },
      {
        id: "growth_mode",
        name: "Growth Mode",
        price: 99,
        currency: "INR",
        duration: "per Month",
        features: [
          { label: "Unlimited Job Applications", included: true },
          { label: "Mail notification from Relevant Job Posted from Employer", included: true }
        ],
        badge: "Most Popular",
        ctaLabel: "Get Growth Mode",
        isPopular: false
      },
      {
        id: "premium_plan",
        name: "Premium Plan",
        price: 199,
        currency: "INR",
        duration: "per Month",
        features: [
          { label: "Unlimited Job Applications", included: true },
          { label: "Mail notification from Relevant Job Posted from Employer", included: true },
          { label: "Profile Boosting / Resume Highlighting", included: true },
          { label: "Direct Recruiter Visibility", included: true }
        ],
        badge: "Premium",
        ctaLabel: "Get Premium Plan",
        isPopular: true
      }
    ]
  },
  company: {
    plans: [
      {
        id: "free_trial",
        name: "Free Trial",
        price: 0,
        currency: "INR",
        duration: "for 3 Months",
        features: [
          { label: "0-5 Job Postings per month", included: true },
          { label: "Basic Visibility", included: true }
        ],
        badge: "Explorer",
        ctaLabel: "Start Free Trial",
        isPopular: false
      },
      {
        id: "growth_mode",
        name: "Growth Mode",
        price: 199,
        currency: "INR",
        duration: "per Month",
        features: [
          { label: "0-20 Job Postings per month", included: true },
          { label: "Resume Access", included: true }
        ],
        badge: "Most Popular",
        ctaLabel: "Get Growth Mode",
        isPopular: false
      },
      {
        id: "premium_plan",
        name: "Premium Plan",
        price: 499,
        currency: "INR",
        duration: "per Month",
        features: [
          { label: "Unlimited Job Postings", included: true },
          { label: "Resume Access", included: true },
          { label: "Priority Listings / Boosting job posts for better visibility", included: true },
          { label: "Access to existing previous applicants DB", included: true }
        ],
        badge: "Premium",
        ctaLabel: "Get Premium Plan",
        isPopular: true
      }
    ]
  }
};
